export default "assets/images/queue-lion-parallax-4faf6edf.png";